export const snakelize = (text: string | number): string => {
  return text
    .toString()
    .replace(/(?<!^)([A-Z])/g, '_$1')
    .toLowerCase()
    .replace(/\s+/g, '_')
}
